import common from '../language/th/common.json'
import login from '../language/th/login.json'
import search from '../language/th/search.json'
import header from '../language/th/search.json'
import button from '../language/th/button.json'
import home from '../language/th/home.json'
import menu from '../language/th/menu.json'
import share from '../language/th/share.json'
import user from '../language/th/user.json'
import master from '../language/th/master.json'
import transfer from './th/transfer.json'
import warehouse from './th/warehouse.json'
import pickpack from './th/pickpack.json'
import changeRawMat from './th/changeRawMat.json'
import systemInfo from './th/systemInfo.json'

export default {
   ...common,
   ...login,
   ...search,
   ...header,
   ...button,
   ...home,
   ...menu,
   ...share,
   ...user,
   ...master,
   ...transfer,
   ...warehouse,
   ...pickpack,
   ...changeRawMat,
   ...systemInfo
}


// WEBPACK FOOTER //
// ./src/wording/language/th.js